import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DarkModeState {
  isDark: boolean;
}

const initialState: DarkModeState = {
  isDark: false,
};

const darkMode = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    setIsDark: (state, action: PayloadAction<boolean>) => {
      state.isDark = action.payload;
    },
    toggleDarkMode: (state) => {
      state.isDark = !state.isDark;
    },
  },
});

export const { setIsDark, toggleDarkMode } = darkMode.actions;
const darkModeReducer  = darkMode.reducer
export default darkModeReducer;